<template>
  <div class="relative w-full lg:w-72 max-w-full">
    <div
      class="absolute left-3 top-0 bottom-0 -translate-y-1/2 text-gray-400 pointer-events-none flex items-center"
    >
      <Search :size="18" />
    </div>
    <input
      type="text"
      placeholder="Search menu..."
      :value="searchQuery"
      @input="searchChange($event.target.value)"
      class="w-full max-w-full bg-gray-100 border border-transparent focus:bg-white focus:border-primary-300 text-gray-900 text-sm rounded-full py-2.5 pl-10 pr-20 outline-none transition-all"
      style="box-sizing: border-box;"
    />
    <button
      v-if="searchQuery"
      type="button"
      aria-label="Clear search"
      @click="clearSearch"
      class="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center gap-1 text-xs font-semibold text-gray-600 hover:text-gray-800 bg-gray-200 hover:bg-gray-300 rounded-full pl-2.5 pr-2 py-1 transition-colors"
    >
      Clear
      <X :size="14" />
    </button>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { Search, X } from "lucide-vue";
export default {
  name: "SearchInput",
  components: {
    Search,
    X
  },
  computed: {
    ...mapGetters(["searchQuery"])
  },
  methods: {
    ...mapMutations(["SET_SEARCH_QUERY"]),
    searchChange(value) {
      this.SET_SEARCH_QUERY(value);
    },
    clearSearch() {
      this.SET_SEARCH_QUERY("");
    }
  }
};
</script>

<style></style>
